import React, { useState } from 'react';
import api from '../services/api';

function Login({ onLogin }) {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!userId || !password) {
      setError('Enter user ID and password');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const result = await api.appLogin(userId, password);
      if (result.status === 'success') {
        localStorage.setItem('app_token', result.token);
        localStorage.setItem('app_user', JSON.stringify(result.user));
        onLogin(result.token, result.user);
      } else {
        setError(result.message || 'Invalid credentials');
      }
    } catch (err) {
      setError('Login failed — check if server is running');
    }
    setLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <div className="login-logo">
          <div className="logo-icon">AI</div>
          <h1>Trading Platform</h1>
          <p>Enter your credentials to continue</p>
        </div>
        <form onSubmit={handleLogin}>
          <div className="login-input-group">
            <input
              type="text"
              placeholder="User ID"
              value={userId}
              onChange={e => setUserId(e.target.value)}
              autoFocus
              disabled={loading}
            />
          </div>
          <div className="login-input-group">
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              disabled={loading}
            />
          </div>
          {error && <div className="login-error">{error}</div>}
          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
